import styled from "styled-components";

import photo1 from "assets/images/Suyane_Mike_HickDuarte_33643.jpg";
import photo2 from "assets/images/Suyane_Mike_HickDuarte_33389.jpg";
import photo3 from "assets/images/Suyane_Mike_HickDuarte_33603.jpg";

export const Container = styled.div`
  width: 100%;
  /* max-width: 1740px; */
  height: 100%;
  min-height: calc(100vh - 160px);
  margin: 0 auto;
  display: flex;
  padding: 80px 96px;
  background-color: #2e0010;

  @media screen and (max-width: 1024px) {
    min-height: 100vh;
    padding: 0;
  }
`;

export const Photo = styled.div`
  width: 100%;
  height: 100%;
  min-height: calc(100vh - 160px);
  background: url(${photo1}) no-repeat center center;
  background-size: cover;

  @media screen and (max-width: 1024px) {
    display: none;
  }
`;

export const Photo2 = styled.div`
  width: 100%;
  height: 100%;
  min-height: calc(100vh - 160px);
  background: url(${photo2}) no-repeat center center;
  background-size: cover;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  position: relative;

  @media screen and (max-width: 1024px) {
    display: none;
  }
`;

export const Photo3 = styled.div`
  width: 100%;
  height: 100%;
  min-height: calc(100vh - 160px);
  background: url(${photo3}) no-repeat center center;
  background-size: cover;
  position: relative;

  @media screen and (max-width: 1024px) {
    min-height: 100vh;
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
  }
`;

export const Text = styled.article`
  width: 100%;
  color: rgba(255, 255, 255, 0.8);
  font-size: 12px;
  line-height: 16px;
  padding: 0 32px 24px 32px;

  @media screen and (max-width: 1024px) {
    display: none;
  }
`;

export const Credit = styled.article`
  display: none;
  width: 100%;
  max-width: 70%;
  color: rgba(255, 255, 255, 0.8);
  font-size: 12px;
  line-height: 16px;
  padding: 0 32px 124px 32px;

  @media screen and (max-width: 1024px) {
    display: block;
  }

  @media screen and (max-width: 414px) {
    font-size: 10px;
    line-height: 16px;
    padding: 0 32px 72px 32px;
  }
`;
